<template>
  <div>
    <div class="card-title h5">8. {{ $t('tabs.impressions.description') }}</div>

    <div class="form-group mb-3">
      <label for="" class="required form-label">{{ $t('tabs.impressions.question1') }}</label>
      <div  class="radio" v-for="ponderacio in options_qualitat_servei" :key="ponderacio.id">
        <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('impressions_qualitat_1') }"
               name="impressions_qualitat_1"
               v-validate="'required|included:' + options_qualitat_servei.map(item => item.value)"
               :value="ponderacio.value"
               v-model="impressions_qualitat_1"
        >
        {{ ponderacio[lang] }}
      </div>
      <span v-show="errors.has('impressions_qualitat_1')" class="invalid-feedback">{{ errors.first('impressions_qualitat_1') }}</span>
    </div>

    <div class="form-group mb-3">
      <label for="" class="required form-label">{{ $t('tabs.impressions.question1') }}</label>
      <div  class="radio" v-for="ponderacio in options_qualitat_servei" :key="ponderacio.id">
        <input type="radio" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('impressions_qualitat_2') }"
               name="impressions_qualitat_2"
               v-validate="'required|included:' + options_qualitat_servei.map(item => item.value)"
               :value="ponderacio.value"
               v-model="impressions_qualitat_2"
        >
        {{ ponderacio[lang] }}
      </div>
      <span v-show="errors.has('impressions_qualitat_2')" class="invalid-feedback">{{ errors.first('impressions_qualitat_2') }}</span>
    </div>

    <div class="form-group">
      <label>{{ $t('tabs.impressions.question3') }}</label>
      <textarea v-model="comentaris" class="form-control" rows="10" maxlength="400" style="resize:none"></textarea>
    </div>


    <p>
    </p><div class="form-group">
    <div class="checkbox">
      <input type="checkbox" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('policies') }"
             v-model="policies"
             name="policies"
             v-validate="'required'"
      >
      <label class="required form-label" v-html="$t('tabs.impressions.policies_accepted')"></label>
      <span v-show="errors.has('policies')" class="invalid-feedback">{{ errors.first('policies') }}</span>
    </div>
  </div>

    <div class="form-group">
      <div class="checkbox">
        <input type="checkbox" class="form-check-input" :class="{'input': true, 'is-invalid': errors.has('rgpd') }"
               v-model="rgpd"
               name="rgpd"
               v-validate="'required'"
        >
        <label class="required form-label" v-html="$t('tabs.impressions.policies')"></label>
        <span v-show="errors.has('rgpd')" class="invalid-feedback">{{ errors.first('rgpd') }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import {list_qualitat_servei} from "@/helpers/data";

export default {
  name: "primeres-impressions",
  props: { lang: { required:true, default:'ca'} },
  data() {
    return {
      impressions_qualitat_1: '',
      impressions_qualitat_2: '',
      comentaris: '',
      policies: false,
      rgpd: false,
      options_qualitat_servei: list_qualitat_servei
    }
  },
  created() {
    this.$validator.localize(this.lang);
    this.$i18n.locale = this.lang;
  },
  methods: {
    async validate() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return false;
      }
      this.$emit('on-validate', this.$data, true);
      return result;
    }
  }
}
</script>

<style scoped>

</style>